import React from "react";
import methodModel from "../../../methods/methods";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { Listbox } from "@headlessui/react";
import { colourStyles } from "../../../utils/constants";
import { IoIosArrowDown } from "react-icons/io";

const Html = ({
  options,
  sort,
  showPlaceHolder,
  selectedValues,
  handleChange,
  showCross,
  displayValue = "name",
  id,
  noOptionsMessage = "No Option Available",
  placeholder,
  required,
  disabled,
  name,
  noDefault,
  className = "",
  theme = "normal",
  dynamicStyle,
  crossIcon,
  noCapitalize = false,
  placeholderCap,
  isLoading = false,
  creatable = false,
  addNewOption = async () => {},
  isFocusedData,
}) => {
  const categoryVal = () => {
    let ext = options && options.find((item) => item.id == selectedValues);
    return ext ? { value: ext.id, label: ext[displayValue] } : "";
  };

  const handleSelectChange = (objectData) => {
    handleChange(objectData?.id);
  };

  const sortedOptions = options || [];

  const handleCreate = async (inputValue) => {
    try {
      const newOption = await addNewOption(inputValue);
      if (newOption && newOption.id) {
        handleChange(newOption.id);
      }
    } catch (error) {}
  };

  const getEnhancedColourStyles = (isFocusedData) => ({
    ...colourStyles,
    control: (styles, props) =>
      colourStyles.control(styles, { ...props, isFocusedData }),
    option: (provided, state) => ({
      ...colourStyles.option(provided, state),
      ...(state.isSelected &&
        !isFocusedData && {
          outline: "1px solid #3B82F6 !important",
          outlineOffset: "-2px",
          boxShadow: "0 0 0 2px #BFDBFE",
        }),
    }),
  });

  return (
    <>
      <div
        className={`selectDropdown ${className} ${disabled ? "disabledDropdown" : ""}`}
      >
        {theme === "search" || creatable ? (
          <>
            {creatable ? (
              <CreatableSelect
                styles={{
                  ...getEnhancedColourStyles(isFocusedData),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                options={
                  sortedOptions?.map((itm) => ({
                    value: itm.id,
                    label: itm[displayValue],
                    imageUrl: itm.imageUrl,
                  })) || []
                }
                placeholder={placeholder}
                isFocusedData={isFocusedData}
                value={categoryVal()}
                // isClearable={crossIcon}
                menuPlacement="auto"
                menuPortalTarget={document.body}
                isDisabled={disabled}
                name={name}
                required={required}
                isLoading={isLoading}
                onChange={(e) => handleChange(e?.value || "")}
                onCreateOption={handleCreate}
                classNamePrefix="react-select"
                // menuIsOpen={true}
                className={`rounded-[0.75rem] ${selectedValues && !isFocusedData ? "!outline-0 ring-none" : ""}`}
              />
            ) : (
              <Select
                styles={getEnhancedColourStyles(isFocusedData)}
                options={
                  sortedOptions?.map((itm) => ({
                    value: itm.id,
                    label: itm[displayValue],
                    imageUrl: itm.imageUrl,
                  })) || []
                }
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                placeholder={placeholder}
                value={categoryVal()}
                // isClearable={crossIcon}
                isDisabled={disabled}
                name={name}
                required={required}
                noOptionsMessage={() => noOptionsMessage}
                isLoading={isLoading}
                menuPlacement="auto"
                onChange={(e) => handleChange(e?.value || "")}
                classNamePrefix="react-select"
                // menuIsOpen={true}
                className={`rounded-[0.75rem] ${selectedValues && !isFocusedData ? "!outline-0 ring-none" : ""}`}
              />
            )}
          </>
        ) : (
          <Listbox
            value={selectedValues}
            onChange={handleSelectChange}
            disabled={disabled}
          >
            <div className="list_box_active_state relative">
              <Listbox.Button
                className={`${noCapitalize ? "lowercase" : ""} relative focus:!outline-[#115B9D] 
                  focus-visible:!outline-[#115B9D] focus-visible:!outline-1 focus:!outline-1 
                  focus-visible:!outline focus:!outline focus-visible:border-indigo-500 
                  focus-visible:ring-1 focus-visible:ring-black/75 focus-visible:ring-offset-1 
                  focus-visible:ring-offset-orange-300 disabled:!bg-gray-200 ${className ? className : "w-full"}
                  flex items-center justify-between gap-1.5 cursor-pointer rounded-extra_large bg-white !px-3 text-left shadow-box border-shadow h-10
                  ${selectedValues && !isFocusedData ? "!outline !outline-1 !outline-[#115B9D]" : ""}`}
              >
                <span
                  className={`text-typo block text-sm font-normal truncate ${noCapitalize && selectedValues ? "lowercase" : ""}`}
                >
                  {selectedValues
                    ? methodModel.find(options, selectedValues, "id")?.[
                        displayValue
                      ] || placeholder
                    : placeholder}
                </span>
                <IoIosArrowDown className="h-[18px] w-5 text-[#75757A]" />
              </Listbox.Button>
              <Listbox.Options
                className={`${dynamicStyle ? "" : "max-h-60"} focus:!outline-[#115B9D] focus:!outline  focus:!outline-1 text-sm absolute z-40 ${className ? className : "min-w-full"}
                  right-0 shadow-lg !py-2 !mt-1.5 overflow-auto bg-white rounded-lg scrollbar`}
              >
                {noDefault || !showPlaceHolder ? null : (
                  <Listbox.Option
                    value={""}
                    className={({ active }) =>
                      `relative cursor-pointer ${noCapitalize && !placeholderCap ? "" : "!capitalize"} select-none !py-3 px-3.5 ${active ? "!bg-[#115B9D] text-white" : "text-gray-900"}`
                    }
                  >
                    <span className={`block font-normal`}>{placeholder}</span>
                  </Listbox.Option>
                )}
                {sortedOptions &&
                  sortedOptions.map((item, itemIdx) => (
                    <Listbox.Option
                      key={itemIdx}
                      disabled={item?.disabled ? true : false}
                      value={item}
                      className={({ active, selected }) =>
                        `relative cursor-pointer ${noCapitalize ? "" : "capitalize"} select-none !py-3 px-3.5 
                        ${item?.isDisabled ? "bg-grey" : ""} 
                        ${active ? "bg-[#115B9D]-2 text-white" : "text-gray-900"}
                        ${selected ? "!outline !outline-1 !outline-[#115B9D] ring-[#115B9D]" : ""}
                        hover:!outline hover:!outline-1 hover:!outline-[#115B9D]
                        focus:!outline focus:!outline-1 focus:!outline-[#115B9D]`
                      }
                    >
                      {({ selected }) => (
                        <span
                          className={`block ${selected ? "font-medium" : "font-normal"}`}
                        >
                          {item[displayValue]}
                        </span>
                      )}
                    </Listbox.Option>
                  ))}
              </Listbox.Options>
            </div>
          </Listbox>
        )}
      </div>
    </>
  );
};
export default Html;
